import { Component } from '@angular/core';
import { ModalService } from '../modal.service';

@Component({
  selector: 'ng-casto-generic-popup',
  templateUrl: './generic-popup.component.html'
})
export class GenericPopupComponent {
  title: string;
  message: string;
  validateBtn: string;

  constructor(public modalService: ModalService) {
    const data = this.modalService.currentDatas;
    this.title = data?.title || 'Attention';
    this.message = data?.message || data;
    this.validateBtn = data?.validateBtn || 'Valider';
  }
}
